/*!


*/
import React, { useState, useEffect } from "react";
//import myimg from './logoccP.png';
import axios from 'axios'
import jwtDecode from "jwt-decode";
import { useHistory } from 'react-router-dom';
import { dtStamp } from './stamp';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Label,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
} from "reactstrap";

import bg from "../../../assets/img/bg/zachary-staines.jpg"


function Login() {
  let history = useHistory();
  const [name, setName] = useState()
  const [pass, setPass] = useState()
  const [msg, setMsg] = useState()
  var typeIs = ""
  React.useEffect(() => {
    document.body.classList.toggle("login-page");
    return function cleanup() {
      document.body.classList.toggle("login-page");
    };
  });

  const auth = () => {
    if (name === "" || name === undefined) {
      return
    }
    if (pass === "" || pass === undefined) {
      return
    }
    setMsg("")
    let browsername = dtStamp().browsername;
    let localdt = dtStamp().localdt;
    // debugger
    axios.post(`${process.env.REACT_APP_APIURL}/tenant/rnmusr`, { email: name, pass: pass, browsername, localdt, typeIs: "Admin" })
      .then(res => {
        let data = jwtDecode(res.headers.arixauth)
        typeIs = data.typeIs
        localStorage.setItem("arixauth", res.headers.arixauth)

      }).then(t => {
        // debugger
        nonotpwindow()
      })
      .catch(e => {
        // debugger
        try {
          setMsg(e.response.data.message)
        } catch (ss) {
          setMsg("System Error")
        }

      });
  }

  const nonotpwindow = () => {
    typeIs === "Admin" ? history.push("/admin/dashboard") : setMsg("Invaid admin ID") && localStorage.setItem({ 'arixauth': "" })
  }


  return (
    <div className="login-page">
      <Container>
        <center>
          <Row style={{ justifyContent: "center" }}>
            <Col className="ml-auto mr-auto" lg="4" md="6" >

              <Form action="" className="form" method="" >
                <Card className="card-login">
                  <CardHeader>
                    <CardHeader>
                      <h3 className="header text-center">Login</h3>
                    </CardHeader>
                  </CardHeader>
                  <CardBody>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-single-02" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder="email" type="text" value={name} onChange={e => setName(e.target.value.trim())} />
                    </InputGroup>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="nc-icon nc-key-25" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Password"
                        type="password"
                        autoComplete="off"
                        value={pass}
                        onChange={e => setPass(e.target.value)}
                      />
                    </InputGroup>
                    <br />
                    <FormGroup>
                      <FormGroup check>
                        <center>
                          <span> Not a Member? Click here to join</span>
                        </center>
                      </FormGroup>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    <Button
                      block
                      className="btn-round mb-3"
                      color="warning"
                      href="#pablo"
                      onClick={(e) => auth()}
                    >
                      Get Started
                    </Button>
                    <center>{msg}</center>
                  </CardFooter>
                </Card>
              </Form>

            </Col>
          </Row>
        </center>
      </Container>

    </div>
  );
}

export default Login;
